import { userService } from '../services';
import { userConstants } from '../constants';
import { alertActions } from '.';
import { history } from '../helpers';

export const userMasterActions = {
    getAll,
    createUser,
    updateUser,
    inActiveRow,
    onHideShow,
    loadingData,
    onHideShowIsActive
};

function getAll(obj) {
    return dispatch => {
        dispatch(request());

        userService.fetchUserData(obj).then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData))
        },
            error => {
                dispatch(loadingData(false));
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }
        );
    };

    function request() { return { type: userConstants.GETALL_REQUEST } }
    function success(datas) { return { type: userConstants.GETALL_SUCCESS, datas } }
    function failure(error) { return { type: userConstants.GETALL_FAILURE, error } }
}

function createUser(data) {
    return dispatch => {
        dispatch(request(data));

        userService.createUser(data).then(
            response => {
                //history.push('/');
                if (response && response.ResponseCode) {
                    if (response.ResponseCode === "200") {
                        dispatch(success(response.ResponseData));
                        dispatch(onHideShow(false));
                        dispatch(alertActions.success(response.ResponseMessage));
                    } else if (response.ResponseCode === "400") {
                        dispatch(alertActions.warning(response.ResponseMessage))
                    } else {
                        dispatch(alertActions.error(response.ResponseMessage))
                    }
                }
            },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }
        );
    };

    function request(data) { return { type: userConstants.CREATE_REQUEST, data } }
    function success(data) { return { type: userConstants.CREATE_SUCCESS, data } }
    function failure(error) { return { type: userConstants.CREATE_FAILURE, error } }
};

function updateUser(data) {
    return dispatch => {
        dispatch(request(data));

        userService.updateUser(data).then(
            response => {
                //history.push('/');                
                if (response && response.ResponseCode) {
                    if (response.ResponseCode === "200") {
                        dispatch(success(data));
                        dispatch(onHideShow(false));
                        dispatch(alertActions.success(response.ResponseMessage))
                    } else if (response.ResponseCode === "400") {
                        dispatch(alertActions.warning(response.ResponseMessage))
                    } else {
                        dispatch(alertActions.error(response.ResponseMessage))
                    }
                }
            },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }
        );
    };

    function request(data) { return { type: userConstants.UPDATE_REQUEST, data } }
    function success(data) { return { type: userConstants.UPDATE_SUCCESS, data } }
    function failure(error) { return { type: userConstants.UPDATE_FAILURE, error } }
};


function inActiveRow(user, isActive) {
    var data = {
        UserId: user,
        IsActive: isActive
    }
    return dispatch => {
        dispatch(request());

        userService.inActiveRow(user, isActive).then(
            response => {
                if (response && response.ResponseCode) {
                    if (response.ResponseCode === "200") {
                        dispatch(success(data));
                        dispatch(onHideShowIsActive(false));
                        dispatch(alertActions.success(response.ResponseMessage))
                    } else if (response.ResponseCode === "400") {
                        dispatch(alertActions.warning(response.ResponseMessage))
                    } else {
                        dispatch(alertActions.error(response.ResponseMessage))
                    }
                }
            },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }
        );
    };

    function request() { return { type: userConstants.ISACTIVE_REQUEST } }
    function success(data) { return { type: userConstants.ISACTIVE_SUCCESS, data } }
    function failure(error) { return { type: userConstants.ISACTIVE_FAILURE, error } }
};

function onHideShow(isbool) {
    return {
        type: userConstants.DIALOG_REQUEST, isbool
    }
}

function loadingData(isbool) {
    return {
        type: userConstants.LOADING_REQUEST, isbool
    }
}

function onHideShowIsActive(isbool) {
    return {
        type: userConstants.DIALOG_ISACTIVE_REQUEST, isbool
    }
}


